import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

import isEmpty from "../../utils/isEmpty";
import { UserDetail } from "../../../services/storage.service";

const state = {
  role: isEmpty(UserDetail.getUserRole()) ? "" : UserDetail.getUserRole(),
  freeProfileQuota: isEmpty(UserDetail.getUserQuota())
    ? ""
    : UserDetail.getUserQuota(),
  isDeleted: isEmpty(UserDetail.getUserIsDeleted())
    ? ""
    : UserDetail.getUserIsDeleted(),
  _id: isEmpty(UserDetail.getUserID()) ? "" : UserDetail.getUserID(),
  username: isEmpty(UserDetail.getUserName()) ? "" : UserDetail.getUserName(),
  email: isEmpty(UserDetail.getUserEmail()) ? "" : UserDetail.getUserEmail(),
  profile: {},
  profileLoading: false,
  resetPassword: "",
  resetPasswordLoading: false,
  changePassword: "",
  changePasswordLoading: false
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
